import { agentName } from "./types";

export const agentRoutes = {
    [agentName.evs_expert]: "evsExpert" as const,
    [agentName.cdp_expert]: "cdpExpert" as const,
    [agentName.doc_reviewer]: "documentReviewer" as const,
    [agentName.quick_answer_suggestor]: "fastAnswer" as const,
} as const;

export function isAgentRouteKey(key?: string): key is keyof typeof agentRoutes {
    return key ? key in agentRoutes : false;
}
